// JIRA: LOGISPRD-14653
import { type ShipperScope, scopedShipperCode, selectableShippers } from '@/components/system/shipperScope'

export interface ShipperSelectOption {
  /** 화주코드 */
  value: string
  /** 화주명 */
  label: string
}

/**
 * `{ value: 화주코드, label: 화주명 }` 셀렉트 옵션을 화주 범위로 좁힌다 — `scopeShippers` 의 셀렉트 옵션판.
 * 화주 계정은 고를 수 있는 화주만 남긴다. 목록에 없어도 세션 값으로 한 줄을 만든다(비우면 칸이 비어 보인다).
 */
export const scopeSelectOptions = (options: ShipperSelectOption[], scope: ShipperScope): ShipperSelectOption[] => {
  if (!scope.locked) return options
  return selectableShippers(scope).flatMap((selectable) => {
    const rows = options.filter((o) => o.value === selectable.shipperCode)
    return rows.length ? rows : [{ value: selectable.shipperCode, label: selectable.shipperName }]
  })
}

/**
 * 화주(`sprNm`) 조건을 범위로 덮는다 — 화주 셀렉트(ShipperCodeSelect)를 쓰는 IV02·IV03·RP06 공용.
 * 화주 계정은 복원(URL)·조회·초기화 어느 경로로 와도 고를 수 있는 화주가 아니면 기본 화주코드(`defaultShipper`)로 조회한다. `sprNm` 은 이름이 아니라
 * 화주코드다 — IV02·IV03 BE 는 sprNm 을 shipperCode 로 받고, RP06 이력 테이블(SPR_NM)도 코드를 저장한다(LOGISPRD-15411).
 */
export const lockShipperName = <T extends { sprNm?: string }>(values: T, scope: ShipperScope): T => (scope.locked ? { ...values, sprNm: scopedShipperCode(scope, values.sprNm) } : values)
